import MainCanvas from "../components/MainCanvas/MainCanvas";
import ModalManager from "../components/ModalManager/ModalManager";
import WorldLoading from "../components/WorldLoading/WorldLoading";
import MuteButton from "../components/MuteButton/MuteButton";
import LandingPage from "../components/LandingPage/LandingPage";
import Lookbook from "../components/Lookbook/Lookbook";
import Header from "../components/Header/Header";
import ExpandedMenu from "../components/ExpandedMenu/ExpandedMenu";
import Intro from "../components/Intro/Intro";

const Main = () => {
  return (
    <>
      <Lookbook />
      <LandingPage />
      <WorldLoading />
      <MainCanvas />
      <ModalManager />
      <MuteButton />
      <ExpandedMenu />
      <Header />
    </>
  );
};

export default Main;
